<template>
  <qc-container title="用户管理" >
    <page-request ref="table" url="/api/mgr/user/expand/list" :table-header="tableHeader" :expend="expend"  :op-width="240">
      <t-button @click="batchUpdateStatus(0)">批量启用</t-button>
      <t-button @click="batchUpdateStatus(1)">批量禁用</t-button>
      <t-button @click="batchSendCoupon()">发放优惠券</t-button>
      <export-excel @action="addExportTask" ref="exportExcel" task-name="用户列表" task-key="member" file-name="member.xlsx" title="批量导出" button-name="批量导出" ></export-excel>
      <template #op="scope">
        <b-button @click="toDetail(scope.row)">查看</b-button>
        <b-button v-show="scope.row.status===0" @click="updateStatus([scope.row.userId],1)">禁用</b-button>
        <b-button v-show="scope.row.status===1" @click="updateStatus([scope.row.userId],0)">启用</b-button>
        <b-button @click="showSendCoupon([scope.row.userId])">发放优惠券</b-button>
        <b-button @click="setVipLevel([scope.row.userId],scope.row.isVip)">设置VIP等级</b-button>
      </template>
    </page-request>
  </qc-container>

  <send-discount ref="sendDiscount" @send="doSend"></send-discount>

  <user-detail ref="userDetail"></user-detail>
  <set-vip-level ref="vip" @load="pageReloadData"></set-vip-level>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import PageRequest from "@/components/base/page-request.vue";
import TButton from "@/components/el/t-button.vue";
import BButton from "@/components/el/b-button.vue";
import SendDiscount from "@view/components/send-discount.vue";
import UserDetail from "@view/user/op/user-detail.vue";
import ExportExcel from "@/components/base/ExportExcel.vue";
import SetVipLevel from "@view/user/op/set-vip-level.vue";

export default {
  name: "list",
  components: {SetVipLevel, ExportExcel, UserDetail, SendDiscount, BButton, TButton, PageRequest, QcContainer},
  data() {
    return {
      tableHeader: [
        {type: "selection", label: ""},
        {type: "user", label: "用户",minWidth:200},
        {prop: "phone", label: "手机",width: 130},
        {prop: "money", label: "消费金额(元)",width: 100},
        {prop: "orderCount", label: "购买订单",width: 100},
        {label: "地区",renderDraw:row=>{
            return (row.province||"")+(row.city||"")+(row.country||"");
          },width: 130},
        {label: "状态",renderDraw:row=>{
            return row.status?"禁用":"正常";
          },width: 100},
        {prop: "lastLoginTime", label: "最近登录时间",width: 160},
        {prop: "createTime", label: "注册时间",width: 160}
      ],
      expend:[
        {label: "用户名称",prop: "nickname"},
        {label: "用户ID",prop: "code"},
        {label: "手机号码",prop: "phone"},
        {label: "用户类型", prop: "isVip",type:"select",options:[{"label":"普通用户","value":"0"},{"label":"VIP1","value":"1"},{"label":"VIP2","value":"2"},{"label":"VIP3","value":"3"},{"label":"VIP4","value":"4"},{"label":"VIP5","value":"5"},{"label":"VIP6","value":"6"}]},
        {label: "登录时间", start: "lastLoginTimeStart", end: "lastLoginTimeEnd", type: "daterange"},
        {label: "注册时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"}
      ],
      ids:[]
    }
  },
  mixins: [tableBase],
  methods: {
    doSend(cardList){
      let cardIds = [];
      cardList.forEach(row=>{
        cardIds.push(row.id);
      })
      this.msgConfirm("/api/mgr/business/userExt/sendUserCard",{userIds:this.ids,cardIds:cardIds},()=>{
        this.visible =false;
        this.message("赠送成功");
      },`是否赠送用户所选优惠卷?`)
    },
    batchUpdateStatus(status) {
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.userId);
        this.updateStatus(ids,status);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    updateStatus(ids,status){
      this.msgConfirm("/api/mgr/business/userExt/updateStatus",{ids:ids,status:status},()=>{
        this.pageReloadData();
      },`您是否要${status?'禁用':'启用'}所选用户?`)
    },
    toDetail(row){
      this.$refs.userDetail.openDrawer(row.userId);
    },
    batchSendCoupon(){
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.userId);
        this.showSendCoupon(ids);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    showSendCoupon(ids){
      this.ids = ids;
      this.$refs.sendDiscount&&this.$refs.sendDiscount.show();
    },
    setVipLevel(ids,isVip){
      this.$refs.vip.open(ids,isVip);

    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
